import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetSmsEmailUnsubscribes as GetSmsEmailUnsubscribesQuery,
    GetSmsEmailUnsubscribesVariables,
} from 'nutshell-graphql-types';

import GET_SMS_EMAIL_UNSUBSCRIBES from '../queries/get-sms-email-unsubscribes.graphql';

export const useGetSmsEmailUnsubscribes = (
    contactId: string
): {
    isUnsubscribed: boolean;
    preferenceCenterLink: string | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetSmsEmailUnsubscribesQuery,
        GetSmsEmailUnsubscribesVariables
    >(GET_SMS_EMAIL_UNSUBSCRIBES, {
        variables: {
            contactId,
        },
        fetchPolicy: 'cache-and-network',
    });

    const isUnsubscribed = data?.contact?.hasUnsubscribedFromEmailAndSmsMarketing ?? false;

    return {
        isUnsubscribed,
        preferenceCenterLink: data?.contact?.preferenceCenterLink ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
